import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthStoreState {
  isJwtLoading: boolean;
}

const initialState = {
  isJwtLoading: true,
} as AuthStoreState;

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    SET_IS_JWT_LOADING(
      state,
      action: PayloadAction<AuthStoreState['isJwtLoading']>,
    ) {
      state.isJwtLoading = action.payload;
    },
  },
});

export default authSlice.reducer;
export const { SET_IS_JWT_LOADING } = authSlice.actions;
